import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";

import Typography from "@mui/material/Typography";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAcceptCompanyRegistrationMutation } from "../../../companiesApiSlice";

const AcceptDialog = ({ onClose, open, companyId, companyName }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [acceptCompany, { isLoading }] = useAcceptCompanyRegistrationMutation();

	const {
		handleSubmit,
		formState: { errors },
	} = useForm({
		shouldFocusError: true,
	});

	const handleAcceptCompany = async () => {
		await acceptCompany({ companyId }).unwrap();
		navigate(`company/${companyId}`);
	};

	return (
		<Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
			<Box sx={{ padding: "30px" }}>
				<Box component="form" onSubmit={handleSubmit(handleAcceptCompany)}>
					<Grid container rowSpacing={3} columnSpacing={2}>
						<Grid size={12}>
							<Box sx={{ textAlign: "center" }}>
								<Typography variant="h5" component="span">
									{t("are_you_sure_to_create_file_in_database_for")}:{" "}
									{companyName}?
								</Typography>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "end" }}>
								<Button type="submit" loading={isLoading} variant="contained">
									{t("create")}
								</Button>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "start" }}>
								<Button variant="contained" color="secondary" onClick={onClose}>
									{t("cancel")}
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Dialog>
	);
};

export default AcceptDialog;
